export const IMPERIAL_CONVERT_VALS = {
    'inch-cm': 2.54,
    'foot-cm': 30.48,
    'yard-cm': 91.44,
    'mile-cm': 160934.4,
    'sq-foot-m': 0.09290304,
    'sq-yard-m': 0.83612736,
    'cub-foot-m': 0.0283168466,
    'cub-yard-m': 0.764554858,
}

export function cmToInch(cmVal: number) {
    return cmVal / IMPERIAL_CONVERT_VALS["inch-cm"];
}

export function inchToCm(inchVal: number) {
    return inchVal * IMPERIAL_CONVERT_VALS["inch-cm"];
}

export function meterToFoot(mVal: number) {
    return mVal * 100 / IMPERIAL_CONVERT_VALS["foot-cm"];
}

export function squareMeterToSquareFoot(m2Val: number){
    return m2Val / IMPERIAL_CONVERT_VALS["sq-foot-m"];
}

export function cubicMeterToCubicFoot(m3Val: number) {
    return m3Val / IMPERIAL_CONVERT_VALS["cub-foot-m"];
}

export function squareMeterToSquareYard(m2Val: number) {
    return m2Val / IMPERIAL_CONVERT_VALS["sq-yard-m"];
}

export function cubicMeterToCubicYard(m3Val: number) {
    return m3Val / IMPERIAL_CONVERT_VALS["cub-yard-m"];
}

export function roundToMax2(val: number){
    return +(+val).toFixed(2);
}